/**
* 基础菜单 订单详情
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click.native="gotoAllOrder()" class="pointer">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="flex_box">
      <div class="order_status">
        <p class="f14">订单状态</p>
        <p class="f20" v-if="detailData.order_status==100">已取消</p>
        <p class="f20" v-else-if="detailData.order_status==101">待付款</p>
        <p class="f20" v-else-if="detailData.order_status==102">已付款</p>
        <p class="f20" v-else-if="detailData.order_status==103">已确认</p>
        <p class="f20" v-else-if="detailData.order_status==104">已出库</p>
        <p class="f20" v-else-if="detailData.order_status==105">待收货</p>
        <p class="f20" v-else-if="detailData.order_status==106">已完成</p>
      </div>
      <div class="Delivery_warehouse">
        <p class="f14">发货仓库</p>
        <p class="f20">{{detailData.area_name}}</p>
      </div>
    </div>
    <div class="flex_box">
      <div class="order_no item f12">
        <p class="color333">订单编号</p>
        <span class="color666">{{detailData.order_code}}</span>
      </div>
      <div class="is_invoice item f12">
        <p class="color333">是否需要发票</p>
        <span class="color666" v-if="detailData.need_invoice==1">需要</span>
        <span v-else>不需要</span>
      </div>
      <div class="is_company_qualification item f12">
        <p class="color333">是否需要公司资质复印件</p>
        <span class="color666" v-if="detailData.need_cert==1">需要</span>
        <span v-else>不需要</span>
      </div>
      <div class="is_priduct_certificate item f12">
        <p class="color333">是否需要产品注册证</p>
        <span class="color666" v-if="detailData.need_product_cert==1">需要</span>
        <span v-else>不需要</span>
      </div>
    </div>
    <div class="flex_box">
      <div class="item f12">
        <p class="color333">银联交易号</p>
        <span class="color666">{{detailData.trade_no}}</span>
      </div>
      <div class="item f12">
        <p class="color333">交易时间</p>
        <span class="color666">{{detailData.pay_time|timestampToTime}}</span>
      </div>
      <div class="item f12">
        <p class="color333">配送方式</p>
        <span class="color666">{{detailData.delivery_com_name}}</span>
      </div>
      <div class="item f12">
        <p class="color333">快递费</p>
        <span class="color666">{{detailData.delivery_amount}}元</span>
      </div>
    </div>
    <div class="flex_box f12 shipping_information">
      <span class="color333 title">收件人信息</span>
      <div class="flex_box">
        <p class="color666">{{detailData.receive_name}}，{{detailData.receive_phone}}，{{detailData.receive_addr}}</p>
        <span class="copy" @click="copy(detailData.receive_name,detailData.receive_phone,detailData.receive_addr)"><img
          src="/static/img/copy.png" alt=""></span>
      </div>
    </div>
    <div class="flex_box f12 order_message">
      <span class="color333 title">订单留言</span>
      <div>
        <p class="color666">{{detailData.order_msg}}</p>
      </div>
    </div>
    <div class="flex_box f12 order_message">
      <span class="color333 title">订单取消原因</span>
      <div>
        <p class="color666">{{detailData.cancel_reason}}</p>
      </div>
    </div>
    <!--列表-->
    <div class="table mt50">
      <div class="flex_box">
        <p class="title f20 color333 fontWeight mb20">商品清单</p>
        <el-button type="primary" size="mini" style="height: 30px;margin-left: 30px" @click="exportExcel">导出清单</el-button>
      </div>
      <el-table size="small" :data="listData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                highlight-current-row v-loading="loading" border
                :summary-method="getSummaries"
                show-summary
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column
          label="序号"
          width="50">
          <template slot-scope="scope">
            {{pageSize * (currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" min-width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_name" label="销售名称" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="model" label="商品包装规格" width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="brand_name" label="商品品牌" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_num" label="客户下单数" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sale_price" label="销售单价" width="150" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div>￥{{scope.row.sale_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="total_sale_price" label="销售单价合计" width="150">
          <template slot-scope="scope">
            <div>￥{{scope.row.total_sale_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="average_price" label="结算单价" width="150">
          <template slot-scope="scope">
            <div>￥{{scope.row.average_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sub_total" label="结算小计" width="150">
          <template slot-scope="scope">
            <div>￥{{scope.row.sub_total}}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="moneyList">
        <div class="moneyText mr50">订单满减金额：<span class="f12">￥</span>{{ detailData.fr_money }}</div>
        <div class="moneyText mr50">使用优惠券金额：<span class="f12">￥</span>{{ detailData.voucher_money }}</div>
        <div class="moneyText mr50">结算小计：<span class="f12">￥</span>{{ detailData.settle_amount }}</div>
      </div>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listData.length"
        >
        </el-pagination>
      </div>
    </div>
    <div class="flex_box">
      <div class="authentication_information mt50" v-if="detailData.receipt_img_url">
        <p class="title f20 color333 fontWeight mb20">支付凭证</p>
        <div class="flex_box">
          <div class="image_box">
            <el-image
              style="width: 120px; height: 90px"
              fit="cover"
              :src="detailData.receipt_img_url"
              :preview-src-list="srcList9">
            </el-image>
            <div class="color333 f12 textCenter img_title">支付凭证</div>
          </div>
        </div>
      </div>
      <div class="authentication_information mt50" v-if="detailData.refund_receipt_imgs&&detailData.refund_receipt_imgs.length">
        <p class="title f20 color333 fontWeight mb20">退款凭证</p>
        <div class="flex_box">
          <div class="image_box" v-for="(imgList,index) in detailData.refund_receipt_imgs" :key="index">
            <el-image
              style="width: 120px; height: 90px"
              fit="cover"
              :src="imgList"
              :preview-src-list="showImg(imgList)">
            </el-image>
            <div class="color333 f12 textCenter img_title">退款凭证</div>
          </div>
        </div>
      </div>
    </div>

    <div class="authentication_information mt50" v-if="authData.busi_lic_url&&(authData.cust_audit_status=='260'||authData.cust_audit_status=='261')">
      <p class="title f20 color333 fontWeight mb20">会员认证信息</p>
      <div class="item f12">
        <p class="color333">会员账号</p>
        <span class="color666">{{detailData.mobile}}</span>
      </div>
      <div class="item f12">
        <p class="color333">会员单位</p>
        <span class="color666">{{authData.company_name}}</span>
      </div>
      <div class="item f12">
        <p class="color333">单位类型</p>
        <span class="color666">{{authData.company_type=='240'?'医疗机构':authData.company_type=='243'?'医疗器械销售公司':''}}</span>
      </div>
      <div class="flex_box">
        <div class="image_box">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.busi_lic_url"
            :preview-src-list="srcList5">
          </el-image>
          <div class="color333 f12 textCenter img_title">营业执照</div>
        </div>
        <div class="image_box" v-if="authData.company_type==240">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.license_url"
            :preview-src-list="srcList6">
          </el-image>
          <div class="color333 f12 textCenter img_title">医疗机构执业许可证</div>
        </div>
        <div class="image_box" v-if="authData.company_type==243">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.medical_lic_url"
            :preview-src-list="srcList7">
          </el-image>
          <div class="color333 f12 textCenter img_title">医疗器械经营许可证</div>
        </div>
        <div class="image_box" v-if="authData.company_type==243">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.class2_license_url"
            :preview-src-list="srcList8">
          </el-image>
          <div class="color333 f12 textCenter img_title" title="第二类医疗器械经营备案凭证" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 113px;padding-left: 5px">第二类医疗器械经营备案凭证</div>
        </div>
      </div>
    </div>
    <div class="authentication_information mt50" v-if="detailData.is_contain_med">
      <p class="title f20 color333 fontWeight mb20">药品采购认证信息</p>
      <div class="item f12">
        <p class="color333">会员账号</p>
        <span class="color666">{{detailData.mobile}}</span>
      </div>
      <div class="item f12">
        <p class="color333">会员单位</p>
        <span class="color666">{{authData.ma_company_name}}</span>
      </div>
      <div class="flex_box">
        <div class="image_box">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.ma_license_url"
            :preview-src-list="srcList1">
          </el-image>
          <div class="color333 f12 textCenter img_title">医疗执业许可证</div>
        </div>
        <div class="image_box">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.ma_busi_lic_url"
            :preview-src-list="srcList2">
          </el-image>
          <div class="color333 f12 textCenter img_title">营业执照</div>
        </div>
        <div class="image_box">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.ma_purchase_letter_url"
            :preview-src-list="srcList3">
          </el-image>
          <div class="color333 f12 textCenter img_title">采购收货委托书</div>
        </div>
        <div class="image_box">
          <el-image
            style="width: 120px; height: 90px"
            fit="cover"
            :src="authData.ma_idcard_license_url"
            :preview-src-list="srcList4">
          </el-image>
          <div class="color333 f12 textCenter img_title">委托人身份证</div>
        </div>
      </div>
    </div>

    <div class="authentication_information flex_box" v-if="detailData.is_contain_med">
      <div class="font-weight mr50" style="margin-top: 20px;">
        <p class="titles textCenter" style="padding: 5px 0">营业执照</p>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">营业执照全称</p>
          <span class="f14 color333">{{businessData.lic_company_name}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">法人</p>
          <span class="f14 color333">{{businessData.legal_persion}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">发证日期</p>
          <span class="f14 color333">{{businessData.date_of_issue}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">注册地址</p>
          <span class="f14 color333">{{businessData.place_of_busi}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">营业执照编号</p>
          <span class="f14 color333">{{businessData.credit_code}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">有效期</p>
          <span class="f14 color333">{{businessData.valid_to_date}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">发证机关</p>
          <span class="f14 color333">{{businessData.registration_authority}}</span>
        </div>
      </div>
      <div class="font-weight mr50" style="margin-top: 20px;">
        <p class="titles textCenter" style="padding: 5px 0">经营许可证</p>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">主要负责人</p>
          <span class="f14 color333">{{medicalData.mgr_man}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">证书编号编号</p>
          <span class="f14 color333">{{medicalData.reg_num}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">发证日期</p>
          <span class="f14 color333">{{medicalData.date_of_issue}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">有效期</p>
          <span class="f14 color333">{{medicalData.valid_to_date}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">发证机关</p>
          <span class="f14 color333">{{medicalData.cert_company}}</span>
        </div>
      </div>
      <div class="font-weight" style="margin-top: 20px;">
        <p class="titles textCenter" style="padding: 5px 0">采购委托书</p>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">委托开始时间</p>
          <span class="f14 color333">{{authorizeData.create_date}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">被授权人身份证号</p>
          <span class="f14 color333">{{authorizeData.id_number}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="f14 color333 label">委托结束时间</p>
          <span class="f14 color333">{{authorizeData.end_date}}</span>
        </div>
      </div>
    </div>

    <div class="billing_information mt50 authBillBox" v-if="detailData.need_invoice">
      <p class="title f20 color333 fontWeight mb20">会员开票信息</p>
      <div class="flex_box">
        <div class="flex_box billing_item">
          <p class="label f14 color666">发票抬头</p>
          <span class="f14 color333">{{invoiceData.company_name}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="label f14 color666">注册地址</p>
          <span class="f14 color333">{{invoiceData.reg_addr}}</span>
        </div>
      </div>
      <div class="flex_box">
        <div class="flex_box billing_item">
          <p class="label f14 color666">发票类型</p>
          <span class="f14 color333">{{invoiceData.invoice_type=='180'?'增值税普通发票（纸质发票）':invoiceData.invoice_type=='181'?'增值税普通发票（电子发票）':'增值税专用发票'}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="label f14 color666">注册电话</p>
          <span class="f14 color333">{{invoiceData.reg_tel}}</span>
        </div>
      </div>
      <div class="flex_box">
        <div class="flex_box billing_item">
          <p class="label f14 color666">纳税识别号</p>
          <span class="f14 color333">{{invoiceData.identification}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="label f14 color666">开户银行</p>
          <span class="f14 color333">{{invoiceData.bank}}</span>
        </div>
      </div>
      <div class="flex_box">
        <div class="flex_box billing_item">
          <p class="label f14 color666">发票内容</p>
          <span class="f14 color333">商品明细</span>
        </div>
        <div class="flex_box billing_item">
          <p class="label f14 color666">开户银行账号</p>
          <span class="f14 color333">{{invoiceData.account}}</span>
        </div>
      </div>
      <div class="flex_box">
        <div class="flex_box billing_item">
          <p class="label f14 color666">收票人手机</p>
          <span class="f14 color333">{{invoiceData.receive_phone}}</span>
        </div>
        <div class="flex_box billing_item">
          <p class="label f14 color666">电子邮箱</p>
          <span class="f14 color333">{{invoiceData.email}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {orderDetail, productListExport} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import router from '../../router'

  export default {
    data() {
      return {
        code: '',
        loading: false, //是显示加载
        listData: [], //用户数据
        detailData: {},
        authData: {},
        businessData: {},
        medicalData: {},
        authorizeData: {},
        invoiceData: {},
        srcList1: [],
        srcList2: [],
        srcList3: [],
        srcList4: [],
        srcList5: [],
        srcList6: [],
        srcList7: [],
        srcList8: [],
        srcList9: [],
        srcList10: [],
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
      }
    },

    /**
     * 创建完毕
     */
    created() {
      this.id = this.$route.query.id;
      this.currentPage = 1;
      if (this.$route.query.id) {
        localStorage.setItem('orderId', this.$route.query.id)
        this.getdata(this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.getdata(localStorage.getItem('orderId'))
      }
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      //点击放大图片
      showImg(img) {
        let imgArr = [];
        imgArr.push(img);
        return imgArr;
      },
      // 获取公司列表
      getdata(id) {
        this.loading = true
        orderDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content || '';
              this.authData = res.content.auth || '';
              this.businessData = res.content.businessLicenseRes || '';
              this.medicalData = res.content.medicalCertificateRes || '';
              this.authorizeData = res.content.authorizeLicenseRes || '';
              this.invoiceData = res.content.invoice || '';
              this.listData = res.content.items || '';
              if(res.content.auth) {
                this.srcList1.push(res.content.auth.ma_license_url)
                this.srcList2.push(res.content.auth.ma_busi_lic_url)
                this.srcList3.push(res.content.auth.ma_purchase_letter_url)
                this.srcList4.push(res.content.auth.ma_idcard_license_url)
                this.srcList5.push(res.content.auth.busi_lic_url)
                this.srcList6.push(res.content.auth.license_url)
                this.srcList7.push(res.content.auth.medical_lic_url)
                this.srcList8.push(res.content.auth.class2_license_url)
                this.srcList9.push(res.content.receipt_img_url)
              }
              // this.srcList10 = res.content.refund_receipt_imgs
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name + ',' + phone + ',' + addr;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
      gotoAllOrder() {
        localStorage.setItem('path', '/order/AllOrder')
        let tag = {
          url: "/order/AllOrder",
          menuname: "订单管理"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({
          path: '/order/AllOrder'
        })
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.label == '结算小计') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else if (column.label == '客户下单数') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index];
          } else if (column.label == '销售单价') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else if (column.label == '销售单价合计') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      //导出
      exportExcel() {
        productListExport(this.id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', '商品清单.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .textCenter {
    text-align: center;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .mr50 {
    margin-right: 50px;
  }

  .f12 {
    font-size: 12px;
  }

  .f14 {
    font-size: 14px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  .user-search {
    margin-top: 20px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .userRole {
    width: 100%;
  }

  .order_status {
    margin-right: 55px;
  }

  .item {
    margin-right: 100px;
    margin-bottom: 15px;
  }

  .item .color333 {
    margin-right: 12px;
  }

  .item p {
    display: inline-block;
  }

  .image_box {
    margin-right: 30px;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .order_status, .Delivery_warehouse {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .order_status .f20 {
    margin-top: 4px;
    color: #333;
    font-weight: 600;
  }

  .Delivery_warehouse .f20 {
    margin-top: 4px;
    color: #333;
    font-weight: 600;
  }

  .shipping_information, .order_message {
    margin-bottom: 15px;
  }

  .shipping_information .title, .order_message .title {
    margin-right: 12px;
  }

  .image_box {
    display: flex;
    flex-direction: column;
  }

  .img_title {
    border: 1px solid #E4E7ED;
    border-top: 0;
    border-radius: 4px;
  }

  .copy {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .titles {
    font-size: 20px;
    color: #666666;
    background: #EBEEF5;
  }
  .authBillBox span{
    width: 500px;
  }

  .moneyList {
    margin-top: 20px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .moneyText {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
  }

</style>





// WEBPACK FOOTER //
// src/views/order/orderDetail.vue